<template>
  <div class="container">
    <div class="navbar">
      <router-link to="/">
        <div class="navbar__container">
          <img class="navbar__container__logo" src="../assets/img/logo.png" />
          <h5 class="navbar__container__name">Harry Beckwith Gardens</h5>
        </div>
      </router-link>
      <nav>
        <ul>
          <li>
            <router-link to="/contact"><button>Free Quote</button></router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  props: {
    msg: String,
  },
}
</script>

<style scoped lang="scss">
// --- Variables ---
$button-color: #63a17c;
$breakpoint-tablet: 768px;

a:visited {
  color: inherit;
}

// Variables
$button-color: #63a17c;
$breakpoint-tablet: 768px;

button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  height: auto;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 5px;
  transition: all 0.5s ease-in-out;
  background-color: $button-color;
  color: white;

  &:hover {
    opacity: 0.8;
  }

  // --- DEFAULT (Mobile-First) BUTTON SIZING (BIGGER ON SMALLER SCREENS) ---
  // Increased to 16px vertical and 20px horizontal padding to make it significantly larger
  padding: 16px 20px;
  width: auto; /* Width defined by padding/content */
}

// --- DESKTOP BUTTON SIZING (SMALLER ON LARGER SCREENS) ---
@media screen and (min-width: $breakpoint-tablet) {
  button {
    font-size: 14px;
    // Desktop padding is intentionally smaller than mobile padding
    padding: 13px 10px;
    width: 157px;
  }
}

.container {
  border-bottom: 1px solid rgb(214, 214, 214);
}

.navbar {
  display: flex; /* KEEPS items on one line (default is row) */
  max-width: 1200px;
  margin: auto;
  align-items: center;
  justify-content: space-between; /* Pushes content to the edges */
  height: 100%;

  // 🟢 ADJUSTED: Increased vertical padding (top/bottom) for a taller navbar on mobile 🟢
  padding: 20px 10px;

  @media screen and (min-width: $breakpoint-tablet) {
      padding: 0px 10px;
  }

  &__container {
    display: flex;
    align-items: center;

    &__name {
      margin: 0;
      color: #3e6549;
      font-size: 13px;

      @media screen and (min-width: $breakpoint-tablet) {
        font-size: 19px;
      }
    }

    &__logo {
      width: 40px;
      @media screen and (min-width: $breakpoint-tablet) {
        width: 80px;
      }
    }
  }

  nav ul {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;

    li {
      list-style-type: none;
    }
  }
}
</style>
